/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-underscore-dangle */
import { v4 as uuidv4 } from 'uuid';
import { Client, DigestFetchPool } from 'edgify-agent-api';
import moment from 'moment';

const getConfigs = () => {
  const defaultHost = window.location.hostname;
  const protocol = window.location.protocol.replace(/:*\/*$/, '') || 'http'; // http or https
  const defaultPort = protocol === 'https' ? window.location.port : 8090;
  const defaultAuth = protocol === 'https' ? 'Bearer' : 'Digest';
  const urlParams = new URLSearchParams(window.location.search);
  let configs = [];

  const agentPort = urlParams.get('agent_port');
  const agentHost = urlParams.get('agent_host');
  const agentProtocol = urlParams.get('agent_protocol');

  if (agentPort || agentHost || agentProtocol) {
    configs = [
      {
        port: agentPort,
        host: agentHost,
        protocol: agentProtocol,
        auth: agentProtocol === 'https' ? 'Bearer' : 'Digest',
      },
    ];
  }

  if (!configs?.length) {
    try {
      // if (protocol === 'https' || ports?.https_port) { // http -> https works only if the https certificate is trusted
      if (protocol === 'https') {
        configs = [
          {
            port: defaultPort,
            protocol: 'https',
            auth: 'Bearer',
          },
        ];
      } else {
        // if (ports?.http_port ?? ports?.reverse_proxy_server_port) {
        configs = [
          {
            port: defaultPort,
            protocol: 'http',
            auth: 'Digest',
          },
        ];
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Failed to load or parse ports', e);
    }
  }

  if (!configs?.length) {
    configs = [{}];
  }
  return configs.map((config, index) => ({
    host: config.host || defaultHost,
    port: config.port || defaultPort,
    setupui: config.setupui || defaultPort,
    protocol: config.protocol || protocol,
    auth: config.auth || defaultAuth,
    index,
  }));
};

export const configs = getConfigs();

export const clearLocalLogin = () => {
  localStorage.removeItem('ACCOUNT_TOKEN');
  localStorage.removeItem('ACCOUNT_TOKEN_UPDATED_AT');
};

const redirectOnUnauthorized = (res) => {
  const { loggedIn, ...state } = history.state ?? {};
  if ([401, 403].includes(res?.status)) {
    clearLocalLogin();
    history.pushState(state, '', '#/login');
    history.go();
  }
};

const fetchRedirectToLoginIUnauthorized =
  (fetcher = fetch) =>
  async (...args) => {
    try {
      const ret = await fetcher(...args);
      redirectOnUnauthorized(ret);
      return ret;
    } catch (e) {
      redirectOnUnauthorized(e);
    }
  };

const DigestAddHeaders = (fetcher, port) => {
  const changeDigestAuthStatusCode = `${port}` === window.location.port;
  return changeDigestAuthStatusCode
    ? (url, options = {}) => {
        const { headers = {} } = options.headers;
        if (changeDigestAuthStatusCode) {
          headers['Authorization-Status-Code'] = '403';
        }
        return fetcher(url, { ...options, headers });
      }
    : fetcher;
};

const Digest = (user, password, port) => {
  const changeDigestAuthStatusCode = `${port}` === window.location.port;
  const digest = new DigestFetchPool({
    user,
    password,
    max: 16,
    statusCode: changeDigestAuthStatusCode ? 403 : undefined,
  });
  return DigestAddHeaders(digest.fetch.bind(digest), port);
};

const Basic =
  (user, password) =>
  (url, options = {}) =>
    fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Basic ${btoa(`${user}:${password}`)}`,
      },
    });

const Bearer =
  (token) =>
  (url, options = {}) =>
    fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${token}`,
      },
    });

const _login = (client, accountToken) => {
  const digest =
    client.auth === 'Digest'
      ? accountToken
        ? Digest('edgify', accountToken, client.port)
        : DigestAddHeaders(fetch, client.port)
      : undefined;
  const bearer =
    client.auth === 'Bearer' && accountToken ? Bearer(accountToken) : undefined;
  const basic =
    client.auth === 'Basic' && accountToken
      ? Basic('edgify', accountToken)
      : undefined;

  const FETCH = digest ?? bearer ?? basic ?? fetch;
  client.request.config.FETCH = fetchRedirectToLoginIUnauthorized(FETCH);
};

const _logout = (client) => {
  const FETCH =
    client.auth === 'Digest' ? DigestAddHeaders(fetch, client.port) : fetch;
  client.request.config.FETCH = fetchRedirectToLoginIUnauthorized(FETCH);
};

export const clients = configs.map(({ protocol, host, port, auth }) => {
  const client = new Client({
    BASE: `${protocol}://${host}:${port}`,
    FETCH: fetchRedirectToLoginIUnauthorized(),
  });
  client.auth = auth;
  client.protocol = protocol;
  client.host = host;
  client.port = port;
  _logout(client);
  return client;
});

/**
 *
 * @param {Config} param0
 * @returns {Client}
 */
const getClientByConfig = ({ port, host, index }) =>
  clients?.[index] ??
  clients[
    configs.findIndex((client) => client.port === port && client.host === host)
  ];

export const login = (config, accountToken) => {
  const client = getClientByConfig(config);
  return _login(client, accountToken);
};

export const logout = (config) => {
  const client = getClientByConfig(config);
  return _logout(client);
};

export const storeLocalLogin = (accountToken) => {
  const accountTokenUpdatedAt = moment(new Date()).toISOString();
  localStorage.setItem('ACCOUNT_TOKEN', accountToken);
  localStorage.setItem('ACCOUNT_TOKEN_UPDATED_AT', accountTokenUpdatedAt);
};

export const loginAll = (accountToken) => {
  storeLocalLogin(accountToken);
  clients.forEach((client) => _login(client, accountToken));
};

export const logoutAll = (accountToken) => {
  clearLocalLogin();
  clients.forEach((client) => _logout(client, accountToken));
  const { loggedIn, ...state } = history.state ?? {};
  history.pushState(state, '', '#/login');
  history.go();
};

export const loginLocal = () => {
  const accountToken = localStorage.getItem('ACCOUNT_TOKEN');
  const accountTokenUpdatedAt = localStorage.getItem(
    'ACCOUNT_TOKEN_UPDATED_AT'
  );
  if (!accountToken || !accountTokenUpdatedAt) {
    clearLocalLogin();
    return false;
  }
  const expire = moment(accountTokenUpdatedAt).add({ days: 1 });
  const current = moment(new Date());
  if (current.isAfter(expire)) {
    clearLocalLogin();
    return false;
  }
  loginAll(accountToken);
  return true;
};

const createMessageHandler = () => {
  let unregister = () => {};
  const handler = (ev) => {
    const { event, payload } = ev.data ?? {};
    if (event === 'login') {
      loginAll(payload);
      unregister();
      const state = { ...history.state, loggedIn: true };
      history.pushState(state, '', '#/');
      history.go();
    }
  };
  unregister = () => {
    window.removeEventListener('message', handler);
  };
  const _register = () => {
    window.addEventListener('message', handler);
  };
  const register = () => {
    unregister();
    _register();
  };
  return { handler, unregister, register };
};

export const getModelDeployment = (config) => {
  const client = getClientByConfig(config);
  return client.configManagement.getApiV2PrivateModelDeployment();
};

export const getLookupTable = (config) => {
  const client = getClientByConfig(config);
  return client.configManagement.getApiV2PrivateLookupTable();
};

export const getSamples = (config, req, flags) => {
  const client = getClientByConfig(config);
  return client.privateSamples.getApiV2PrivateSamples({
    ...req,
    local: flags?.local,
  });
};

export const updateSamples = (config, samples, newLabel, flags) => {
  const client = getClientByConfig(config);
  return Promise.all(
    samples.map(async (sample) => {
      return client.privateSamples.patchApiV2PrivateSamples({
        requestBody: {
          ...sample,
          dataset_type: sample.datasetType,
          label: newLabel,
        },
        local: flags?.local,
      });
    })
  );
};

export const deleteSamples = (config, samplesIds, flags) => {
  if (!samplesIds.length) {
    return;
  }
  const client = getClientByConfig(config);
  return client.privateSamples.deleteApiV2PrivateSamples({
    requestBody: samplesIds,
    local: flags?.local,
  });
};

export const CAPTURE_TRIGGER = 'setup-ui';
export const LABEL_TRIGGER = 'setup-ui';

export const makePrediction = async (config, _options, flags) => {
  const client = getClientByConfig(config);
  const {
    image,
    family,
    capture_trigger,

    _predict = true,
    _quiet = true,
  } = _options ?? {};

  let requestBody;
  let promise;
  const start = performance.now();
  let action = '';
  if (_predict) {
    if (image) {
      action = 'predict';
      requestBody = {
        image,
        capture_trigger: capture_trigger ?? CAPTURE_TRIGGER,
        family,
      };
      promise = client.privateCapture.postApiV2PrivatePredict({
        report: flags?.report,
        requestBody,
      });
    } else {
      action = 'capture-and-predict';
      requestBody = {
        capture_trigger: capture_trigger ?? CAPTURE_TRIGGER,
        family,
      };
      promise = client.privateCapture.postApiV2PrivateCaptureAndPredict({
        report: flags?.report,
        requestBody,
      });
    }
  } else {
    action = 'capture';
    promise = client.privateCapture
      .postApiV2PrivateCapture()
      .then((response) => {
        try {
          response.uuid = response?.uuid ?? uuidv4();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
        return response;
      });
  }
  let response;
  let error;
  try {
    response = await promise;
  } catch (e) {
    error = e;
  }
  const end = performance.now();
  const _duration = end - start;
  if (!_quiet) {
    if (response) {
      // eslint-disable-next-line no-console
      console.log(
        `It took ${_duration} ms to take picture and make prediction from agent with config ${JSON.stringify(
          config
        )}`
      );
    } else {
      // eslint-disable-next-line no-console
      console.error(`failed to "${action}"`, error);
    }
  }
  return {
    response,
    error,
    request: {
      action,
      body: requestBody,
    },
    _duration,
    _options,
    config,
  };
};

export const makePredictions = async (_options, flags) => {
  const start = performance.now();
  const { quiet, ...__options } = _options ?? {};
  const results = await Promise.allSettled(
    configs.map((config) => makePrediction(config, __options, flags))
  );
  const end = performance.now();
  const _duration = end - start;

  // let groupId;
  const processed = results.map((p) => {
    if (p.status === 'rejected') {
      return { error: p.reason };
    }
    return p.value;
  });
  if (!quiet) {
    // eslint-disable-next-line no-console
    console.log(
      `It took ${_duration} ms to take picture and make prediction from all agents with configs ${JSON.stringify(
        configs
      )}`
    );
    processed
      .filter((p) => p.error)
      // eslint-disable-next-line no-console
      .forEach((p) => console.error(JSON.stringify(p.config), p));
  }
  return processed;
};

/**
 *
 * @param {{label: string, family?: string}} labelObject
 * @param {*} predictions
 * @returns
 */
export const createGroundTruth = (labelObject, predictions) => {
  return Promise.all(
    predictions.map((prediction) => {
      const { config, response, request, _options = {} } = prediction;
      const client = getClientByConfig(config);
      const { image, uuid } = response;
      const { category, group_id, img_source } = _options;
      const { label } = labelObject;
      const capture_trigger =
        request?.capture_trigger ??
        _options?.capture_trigger ??
        CAPTURE_TRIGGER;
      let family = labelObject?.family ?? request?.family ?? _options?.family;
      if (family === 'ignore') family = undefined;
      const label_trigger = _options?.label_trigger ?? LABEL_TRIGGER;
      return client.privateSamples.putApiV2PrivateSamples1({
        uuid,
        report: true,
        requestBody: {
          // uuid,
          capture_trigger,
          category,
          family,
          group_id,
          image,
          img_source,
          label,
          label_trigger,
        },
      });
    })
  );
};

export const getSettings = (config) => {
  const client = getClientByConfig(config);
  return client.configManagement.getApiV2PrivateConfig();
};

export const setSettings = (config, settings) => {
  const client = getClientByConfig(config);
  return client.configManagement.postApiV2PrivateConfig({
    requestBody: settings,
  });
};

export const restartAgent = (config) => {
  const client = getClientByConfig(config);
  return client.configManagement.postApiV2PrivateRestart();
};

export const getSample = (config, uuid, flags) => {
  const client = getClientByConfig(config);
  return client.privateSamples.getApiV2PrivateSamples1({
    uuid,
    local: flags?.local,
  });
};

const loggedLocal = loginLocal();
if (!loggedLocal && !history?.state?.loggedIn) {
  const messageHandler = createMessageHandler();
  messageHandler.register();
  if (window.opener) {
    try {
      window.opener.postMessage({ event: 'load' }, '*');
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error(ex);
    }
  }
}
